import LayoutBarista from "../../../layout/layout_barista";
import CategoryManagement from "./components/categoryManage";
export function MenuManagement() {
  return (
    <>
      <LayoutBarista>
        <CategoryManagement/>
      </LayoutBarista>
    </>
  );
}
